import React from "react";
import { useLanguage } from "@/context/LanguageContext";

export const LEAD_STATUSES = ["new", "contacted", "in_progress", "closed"];

// Color-coded per status using brand tokens only (no raw greens/reds).
const STATUS_STYLES = {
  new: "bg-[rgba(139,30,63,0.10)] text-[var(--brand-burgundy)] ring-[rgba(139,30,63,0.25)]",
  contacted: "bg-[rgba(11,27,58,0.08)] text-[var(--brand-navy)] ring-[rgba(11,27,58,0.22)]",
  in_progress: "bg-[rgba(180,83,9,0.10)] text-[var(--warning)] ring-[rgba(180,83,9,0.25)]",
  closed: "bg-[rgba(15,118,110,0.10)] text-[var(--success)] ring-[rgba(15,118,110,0.25)]",
};

export const normalizeStatus = (s) => (LEAD_STATUSES.includes(s) ? s : "new");

export const StatusBadge = ({ status, className = "", testId }) => {
  const { t } = useLanguage();
  const key = normalizeStatus(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-semibold ring-1 ring-inset ${STATUS_STYLES[key]} ${className}`}
      data-testid={testId || `status-badge-${key}`}
      data-status={key}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
      {t.admin.statuses[key]}
    </span>
  );
};
